import BaseApi from '../BaseApi';
import { AgentAdminConverter } from './AgentAdminConverter';

class AgentAdminApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api/agent_admin`;
    this.converter = new AgentAdminConverter();
  }

  getNotifications = () =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/notifications`,
      null,
      null,
      this.converter.convertNotifications,
    );

  getFeedbackLink = () =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/link/`,
      null,
      null,
      data => data,
    );

  updateFeedbackLink = (title, link) =>
    this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/link/`, { title: title, link: link });

  dropNotification = id =>
    this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/notifications`, { notification_id: id });
}

export default AgentAdminApi;
